import { put, call } from 'redux-saga/effects';
import endpoint from "../../const/backend";
const axios = require('axios');

function apiAdd(body){
    return body.addRoom({
        variables:{ 
            name: body.room.name,
            link: body.room.link,
            branch: body.room.branch
        }
    })
}
  
export function* addRoom(action){
    try{
        const response = yield call(apiAdd, action.body);
        yield put({ type: "SUCCESS_ADD_ROOM", payload: { data: response } });
    }catch(err){
        yield put({ type: "FAILURE_ADD_ROOM" })
    }
}

function apiUpdate(body){
    return body.updateRoom({
        variables:{ 
            _id: body.room._id, 
            name: body.room.name,
            link: body.room.link,
            branch: body.room.branch
        }
    });
}

export function* updateRoom(action){
    try{
        const response = yield call(apiUpdate, action.body);
        yield put({ type: "SUCCESS_UPDATE_ROOM", payload: { data: response } });
    }catch(err){
        yield put({ type: "FAILURE_UPDATE_ROOM" })
    }
}

function apiRemove(body){
    return body.removeRoom({
        variables:{ 
            _id: body._id
        }
    });
}

export function* removeRoom(action){
    try{
        const response = yield call(apiRemove, action.body);
        yield put({ type: "SUCCESS_REMOVE_ROOM", payload: { data: response } });
    }catch(err){
        yield put({ type: "FAILURE_REMOVE_ROOM" })
    }
}

function apiRooms(body){
    return axios.post(endpoint+"/rooms", body , 
        { headers: { 'Content-Type': 'application/json'}
    });
}
  
export function* getRooms(action){
    try{
        const response = yield call(apiRooms, action.body);
        yield put({ type: "SUCCESS_GET_ROOMS", payload: { data: response } });
    }catch(err){
        yield put({ type: "FAILURE_GET_ROOMS" })
    }
}


// WEBPACK FOOTER //
// ./src/store/sagas/room.js